"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const lodash_1 = require("lodash");
const common_1 = require("../../common");
const PrettyChoices_1 = __importDefault(require("../../PrettyChoices"));
function RuleKeyDropdown(props) {
    const { choiceGroups, initialValue } = props;
    const onChange = (item) => props.onChange(item.value);
    const renderDropdownMenu = (menuProps) => {
        const onSelect = (_tag, item) => {
            const itemToSelect = item;
            menuProps.selectItem(itemToSelect);
        };
        return (core_1.jsx(PrettyChoices_1.default, Object.assign({}, menuProps, { choiceGroups: choiceGroups, onClickOutside: menuProps.closeMenu, onClose: menuProps.closeMenu, onFocus: () => { }, onInsertTag: onSelect })));
    };
    const onBlur = (_e, meta) => {
        if (!meta.didBlurWithin) {
            meta.closeMenu();
        }
    };
    const initialSelectedItem = lodash_1.find(lodash_1.flatMap(choiceGroups, 'items'), (item) => item.value === initialValue);
    return (core_1.jsx(common_1.Dropdown, { initialSelectedItem: initialSelectedItem, items: props.choiceGroups, menuAriaLabel: "match fields", onBlur: onBlur, onChange: onChange, placeholder: "Choose field\u2026", renderFloatingMenu: renderDropdownMenu }));
}
exports.default = RuleKeyDropdown;
